import React from 'react'
import Layout from '../components/Layout'
import Seo from '../components/SEO/PageSeo'

const NewsLetter = () => {
  return (
    <Layout>
      <Seo />
      <section className="newsletter-page">
        <div className="page-center">
          <h1>Ne manquez-rien & et recevez les dernières mise à jour!</h1>
          <h4>Mise à jour toutes les quelques semaines</h4>
          <form
            className="contact-form"
            name="newsletter-subscription"
            method="post"
            netlify-honeypot="bot-field"
            data-netlify="true"
            action="/success"
          >
            <input
              type="hidden"
              label="tu devrais pas voir ceci"
              name="bot-field"
            />

            <input
              type="text"
              name="name"
              placeholder="Your name"
              className="form-control"
            />

            <input
              type="email"
              name="email"
              placeholder="Your email"
              className="form-control"
            />
            <button type="submit" className="btn form-control submit-btn">
              s'inscrire
            </button>
          </form>
        </div>
      </section>
    </Layout>
  )
}

export default NewsLetter
